import { createPortal } from 'react-dom';

import { ViewportToolbar } from './viewport-toolbar';

import { useViewportToolbars } from '@/hooks/use-viewport-toolbars';

/**
 * Bridge component that renders ViewportToolbar instances into
 * imperatively-created viewport containers via React portals.
 *
 * Place as a sibling of ViewportContainer within the VisualizationProvider tree.
 */
export function ViewportToolbarManager() {
    const viewports = useViewportToolbars();

    if (viewports.length === 0) return null;

    return (
        <>
            {viewports.map((vp) =>
                createPortal(
                    <ViewportToolbar key={vp.id} viewportId={vp.id} viewportType={vp.type} />,
                    vp.container,
                    `viewport-toolbar-${vp.id}`
                )
            )}
        </>
    );
}
